import { Text } from "@pentabd/ui";

interface StatusTextPropType {
  amount: number;
}

export const StatusText = ({ amount }: StatusTextPropType) => {
  let color;
  if (amount > 0 && amount < 10) {
    color = "danger";
  } else if (amount >= 10 && amount < 25) {
    color = "warning";
  } else if (amount > 25) {
    color = "success";
  } else {
    color = "";
  }

  return <Text color={color}>{amount && amount >= 0 ? amount : "..."}</Text>;
};
